var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 20,
  viewBox: "0 0 14 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_122",
  "data-name": "Path 122",
  d: "M9.978,21.638a2.487,2.487,0,0,1-.791-.183,1.618,1.618,0,0,1-.879-1.826l1.055-5.295H7.781a1.737,1.737,0,0,1-1.582-1.1,1.572,1.572,0,0,1,.352-1.826l8.35-9.22a1.71,1.71,0,0,1,2.022-.365A1.618,1.618,0,0,1,17.8,3.653L16.746,8.948h1.582a1.737,1.737,0,0,1,1.582,1.1,1.572,1.572,0,0,1-.352,1.826l-8.35,9.22A1.7,1.7,0,0,1,9.978,21.638Z",
  transform: "translate(-6.055 -1.638)",
  fill: "#fbc52d"
})));
export default __webpack_public_path__ + "static/media/NewProducts.5221dba7.svg";
export { SvgComponent as ReactComponent };